import {
    BroadcastStatus,
    PrivateRequestStatus,
    StreamStatus,
} from "@multimediallc/web-utils"
import { selectStreamStatus } from "../../../store/broadcastSlice"
import { useAppSelector } from "../../../store/hooks"
import { selectRoomPrivateRequestStatus } from "../../../store/roomSlice"
import { BroadcastRoomSubject } from "../BroadcastRoomSubject"
import { MobileBroadcastChat } from "../MobileBroadcastChat"
import { useMobileBroadcastContext } from "../mobileBroadcastContext"
import { MuteUnmuteButton } from "../MuteUnmuteButton"
import { PrivateShowAcceptDenyModal } from "../PrivateShowAcceptDenyModal"
import { RecordButton } from "../RecordButton"
import { ReturnFromAwayUI } from "../ReturnFromAwayUI"
import { RoomStatusAndFPS } from "../RoomStatusAndFPS"
import { TokenCount } from "../TokenCount"
import "./MobileBroadcastLandscapeUI.scss"

export const MobileBroadcastLandscapeUI = () => {
    const privateShowRequestStatus = useAppSelector(
        selectRoomPrivateRequestStatus,
    )
    const { broadcastStatus } = useMobileBroadcastContext()
    const streamStatus = useAppSelector(selectStreamStatus)

    return (
        <div
            className="MobileBroadcastLandscapeUI"
            data-testid="mobilebroadcast-landscape-ui"
        >
            <div className="MobileBroadcastLandscapeUI__TopSection">
                <div className="MobileBroadcastLandscapeUI__TopSection__Left">
                    <RoomStatusAndFPS />
                </div>
                <div className="MobileBroadcastLandscapeUI__TopSection__Center">
                    {broadcastStatus !== BroadcastStatus.Offline &&
                        streamStatus === StreamStatus.Away && (
                            <ReturnFromAwayUI />
                        )}
                </div>
                <div className="MobileBroadcastLandscapeUI__TopSection__Right">
                    <BroadcastRoomSubject />
                    <TokenCount />
                    {privateShowRequestStatus &&
                        privateShowRequestStatus.status ===
                            PrivateRequestStatus.requested && (
                            <PrivateShowAcceptDenyModal />
                        )}
                </div>
            </div>
            <div className="MobileBroadcastLandscapeUI__BottomSection">
                <div className="MobileBroadcastLandscapeUI__BottomSection__Left">
                    <MobileBroadcastChat />
                </div>
                <div className="MobileBroadcastLandscapeUI__BottomSection__Right">
                    <RecordButton />
                    <MuteUnmuteButton />
                </div>
            </div>
        </div>
    )
}
